const STEPS = [
  { n: "01", title: "Drop the Footage", body: "Send raw files via Drive, Frame.io, or your preferred drop. We confirm scope in hours, not days." },
  { n: "02", title: "We Edit", body: "Reaction cut, B-roll, captions, color, copyright-safe music. Internal QC before you ever see it." },
  { n: "03", title: "Revisions on Tap", body: "Frame-accurate notes via Frame.io. Two structured rounds, then unlimited polish." },
  { n: "04", title: "You Publish", body: "Final exports in every aspect ratio your platforms need. Thumbnails, titles, end-screens optional." },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="border-b border-white/10 py-10 md:py-16 relative">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-10">
          <h2 className="mt-3 font-oswald uppercase text-5xl md:text-7xl lg:text-8xl font-bold leading-[0.95]">
            From raw <span className="font-cormorant italic font-medium normal-case lowercase text-white/70">to ready</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {STEPS.map((s, i) => (
            <div key={s.n} data-testid={`process-step-${i}`} className="bg-[#070707] p-8 md:p-10 min-h-[260px] flex flex-col">
              <p className="font-oswald text-6xl md:text-7xl text-[#00A0E4] leading-none">{s.n}</p>
              <h3 className="mt-6 font-oswald uppercase text-2xl">{s.title}</h3>
              <p className="mt-3 text-white/60 text-sm leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
